export enum ECpdDraftStatus {
  init = 'init',
  success = 'success',
  fail = 'fail',
  loading = 'loading',
}

export enum ECpdLabelModalView {
  None = 'none',
  Sdelka = 'sdelka',
  Documents = 'documents',
  Profi = 'profi',
  RealFlat = 'realFlat',
}

export enum ECpdPrelandingModalView {
  None = 'none',
  Homeowner = 'homeowner',
  Searcher = 'searcher',
}

export interface ICpdLabelModalState {
  isOpen: boolean;
  modalView: ECpdLabelModalView;
}

export interface ICpdPrelandingModalState {
  isOpen: boolean;
  modalView: ECpdPrelandingModalView;
}

export interface ICPDState {
  isCpdAvailable: boolean;
  modals: {
    labelModal: ICpdLabelModalState;
    prelandingModal: ICpdPrelandingModalState;
    cpdDraftId?: number;
    cpdDraftStatus: ECpdDraftStatus;
    source?: string;
    cianSource?: string;
    customCpdDealType?: string;
  };
}
